import { MessagesSquareIcon, SearchIcon, SparklesIcon } from 'lucide-react'

const features = [
  {
    name: 'SEO',
    description:
      '"memes" have a keyword search volume of 1.5mn per month. Generate hundreds of memes for "{your niche} memes" in minutes',
    icon: SearchIcon,
  },
  {
    name: 'Custom Bots',
    description:
      'Build bots within your Slack or Discord channel where users can use memes to engage with each other',
    icon: MessagesSquareIcon,
  },
  {
    name: 'Fun Tools',
    description:
      'Build custom application and viral marketing campaigns where users can generate memes for your niche',
    icon: SparklesIcon,
  },
]

export default function MemeAPIUseCases() {
  return (
    <div className='bg-white py-12 sm:py-16'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='mx-auto max-w-2xl lg:text-center'>
          <h2 className='text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
            Use cases for Meme APIs
          </h2>
        </div>
        <div className='mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl'>
          <dl className='grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-3 lg:gap-y-16'>
            {features.map((feature) => (
              <div key={feature.name} className='relative pl-16'>
                <dt className='text-base font-semibold leading-7 text-gray-900'>
                  <div className='absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-indigo-600'>
                    <feature.icon
                      aria-hidden='true'
                      className='h-6 w-6 text-white'
                    />
                  </div>
                  {feature.name}
                </dt>
                <dd className='mt-2 text-base leading-7 text-gray-600'>
                  {feature.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}
